// extracted by mini-css-extract-plugin
module.exports =  {"userSelect_none":"_93444fe79c--userSelect_none--g_J_6","userSelect_auto":"_93444fe79c--userSelect_auto--f5UVj","userSelect_all":"_93444fe79c--userSelect_all--v9qxk"};